import { Box, styled } from "@mui/material";

export const CastCardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexWrap: "wrap",
  justifyContent: "center",
}));
